// @flow
import Grid from "@mui/material/Grid2";
import React, { useContext } from 'react';
import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";
import SkeletonLoaderWrapper from "../../components/mui/general/skeletonLoaderWrapper/skeletonLoaderWrapper";
import { access_registrations, access_user } from "../../helpers/rights";
import useKpis from "../../hooks/user/useKpis";
import { NAVIGATION } from "../../locales/components/namespaces";
import PermissionHOC from "../../modules/permission/components/permissionHOC/permissionHOC";
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';
import GroupsIcon from '@mui/icons-material/Groups';
import LoginIcon from '@mui/icons-material/Login';
import EventNoteIcon from '@mui/icons-material/EventNote';
import Kpi from "./partials/kpi";

type Props = {};

const Home = (props: Props) => {
	const { data, loading } = useKpis()
	const { t } = useTranslation(NAVIGATION)
	return (
		<SkeletonLoaderWrapper loading={loading}>
			<Box>
				<Grid
					container
					spacing={2}
					sx={{ marginLeft: '0px', marginTop: '15px' }}
				>
					<PermissionHOC requiredPermissions={[access_user]}>
						<Grid size={{ sm: 12, md: 4 }}>
							<Kpi
								title={t('Active Projects')}
								icon={WorkOutlineIcon}
								iconColor={'#1976d2'}
							>
								{data.projects}
							</Kpi>
						</Grid>
					</PermissionHOC>
					<PermissionHOC requiredPermissions={[access_user]}>
						<Grid size={{ sm: 12, md: 4 }}>
							<Kpi
								title={t('Workers Total')}
								icon={GroupsIcon}
								iconColor={'#43a047'}
							>
								{data.workers}
							</Kpi>
						</Grid>
					</PermissionHOC>
					<PermissionHOC requiredPermissions={[access_user]}>
						<Grid size={{ sm: 12, md: 4 }}>
							<Kpi
								title={t('Foremen Total')}
								icon={GroupsIcon}
								iconColor={'#1976d2'}
							>
								{data.foremen}
							</Kpi>
						</Grid>
					</PermissionHOC>
					<PermissionHOC requiredPermissions={[access_user, access_registrations]}>
						<Grid size={{ sm: 12, md: 6 }}>
							<Kpi
								title={t('Last Login')}
								icon={LoginIcon}
								iconColor={'#1976d2'}
							>
								{data.lastLogin}
							</Kpi>
						</Grid>
					</PermissionHOC>
					<PermissionHOC requiredPermissions={[access_user, access_registrations]}>
						<Grid size={{ sm: 12, md: 6 }}>
							<Kpi
								title={t('Last Entry')}
								icon={EventNoteIcon}
								iconColor={'#43a047'}
							>
								{data.insertDate}
							</Kpi>
						</Grid>
					</PermissionHOC>
				</Grid>
			</Box>
		</SkeletonLoaderWrapper>
	)
};

export default Home